// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ForgotPassword_componentWrapper__ljEn-","form":"ForgotPassword_form__-LyvM","actions":"ForgotPassword_actions__TmFV9"};